module.exports = __webpack_public_path__ + "img/yuuka kazami_lw.23e80307.png";